import React, { HTMLAttributes } from 'react';
import classnames from 'classnames';

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
	icon?: string,
	type?: 'info' | 'success' | 'warning' | 'error',
	alertContent: React.ReactNode | string
}

const Alert = (props: AlertProps) => {
	const {
		icon = 'icon-info',
		type = 'info',
		alertContent,
		...rest
	} = props;

	return (
		<div
			{...rest}
			className={classnames(
				'alert-not-toast',
				{ 'alert-info': type === 'info' },
				{ 'alert-success': type === 'success' },
				{ 'alert-warning': type === 'warning' },
				{ 'alert-error': type === 'error' },
			)}
		>
			<span className={`icon icon-left ${icon}`} />
			<div className="alert-content">
				{ typeof alertContent === 'object' ? alertContent : (
					<p>{alertContent}</p>
				)}
			</div>
		</div>
	);
};

export default Alert;
